/**
 * Returns true when the event target is a text-editing control where global shortcuts
 * should not fire (except callers that explicitly allow them, e.g. Ctrl+Enter to send).
 */
export function isEditableTarget(target) {
  if (!target || typeof target !== 'object') {
    return false;
  }
  const el = target;
  const tag = el.tagName?.toLowerCase();
  if (tag === 'input' || tag === 'textarea' || tag === 'select') {
    return true;
  }
  if (el.isContentEditable) {
    return true;
  }
  return false;
}

export function isModKey(e) {
  return e.ctrlKey || e.metaKey;
}

/**
 * True on macOS. Two different things depend on this and they are easy to
 * conflate: the modifier LABEL in shortcut hints, and — more importantly — the
 * fact that on macOS **Ctrl+click IS the right-click gesture**. Anything
 * treating Ctrl as "add to selection" will therefore fight the context menu on
 * a Mac, which is why the multi-select modifier there must be ⌘ alone.
 */
export function isMacPlatform() {
  if (typeof navigator === 'undefined') return false;
  const platform = navigator.platform || '';
  const ua = navigator.userAgent || '';
  return /Mac|iPhone|iPad|iPod/i.test(platform) || /Mac OS X/i.test(ua);
}

/** Ctrl on Windows/Linux, ⌘ on macOS (for shortcut hints in the UI). */
export function getModKeyLabel() {
  return isMacPlatform() ? '⌘' : 'Ctrl';
}

function formatModPlusKey(key) {
  const mod = getModKeyLabel();
  return mod === '⌘' ? `⌘ ${key}` : `Ctrl+${key}`;
}

/** Shortcuts shown in the request builder response empty state. */
export function getRequestShortcutHints() {
  const modPlus = formatModPlusKey;
  return [
    { label: 'Send request', keys: modPlus('Enter') },
    { label: 'Save request', keys: modPlus('S') },
    { label: 'Rename', keys: `F2 / ${modPlus('E')}` },
    { label: 'Duplicate', keys: modPlus('D') },
    { label: 'New request tab', keys: modPlus('T') },
  ];
}

